module.exports = __webpack_public_path__ + "static/byev__icon-d2acaddfde24bd2712487bbac260e1ff.svg";